module.exports = __webpack_public_path__ + "img/jisusaiche_icon.556cdc9d.png";